import React, { useState } from 'react';
import { Check, ContentCopy } from '@mui/icons-material';

const CodeExample = ({ code, language, showLineNumbers = false }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(code);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Erreur de copie:', err);
        }
    };

    const formatCode = (code) => {
        return code.split('\n').map((line, index) => ({
            number: index + 1,
            content: line
        }));
    };

    const lines = formatCode(code);

    return (
        <div className="relative">
            {/* En-tête du code */}
            <div className="flex justify-between items-center bg-gray-800 px-4 py-2 rounded-t-lg">
                <span className="text-gray-300 text-sm font-mono">{language}</span>
                <button
                    onClick={copyToClipboard}
                    className="flex items-center space-x-2 text-gray-300 hover:text-white transition-colors text-sm"
                >
                    {copied ? (
                        <>
                            <Check className="text-green-400" />
                            <span>Copié !</span>
                        </>
                    ) : (
                        <>
                            <ContentCopy />
                            <span>Copier</span>
                        </>
                    )}
                </button>
            </div>

            {/* Code */}
            <div className="bg-gray-900 rounded-b-lg overflow-x-auto">
        <pre className="text-sm leading-relaxed">
          <code className="flex">
            {showLineNumbers && (
                <div className="text-gray-500 text-right pr-4 bg-gray-800 select-none">
                    {lines.map((line) => (
                        <div key={line.number} className="px-3 py-1">
                            {line.number}
                        </div>
                    ))}
                </div>
            )}
              <div className="flex-1 py-2">
              {lines.map((line, index) => (
                  <div key={index} className="px-4 py-1 hover:bg-gray-800 transition-colors">
                      <span className="text-gray-200">{line.content}</span>
                  </div>
              ))}
            </div>
          </code>
        </pre>
            </div>
        </div>
    );
};

export default CodeExample;